import { Component, HostListener } from '@angular/core';
import { TenantFolderDto } from 'app/api/models/tenant/tenantFolderDto';
import { TenantsService } from 'app/state/tenants.service';
import { Table } from 'primeng/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-tenant-folders',
  templateUrl: './tenant-folders.component.html',
  styleUrl: './tenant-folders.component.scss',
})
export class TenantFoldersComponent {
  constructor(private tenantService: TenantsService) {}
  deleteConfirmation: TenantFolderDto | null = null;

  folders: TenantFolderDto[] = [];
  newFolderText: string = '';
  innerWidth = 0;
  @HostListener('window:resize', ['$event'])
  ngOnInit(): void {
    this.refreshData();
    this.innerWidth = window.innerWidth;
  }
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  addFolder() {
    if (this.newFolderText.trim()) {
      let newFolder = new TenantFolderDto();
      newFolder.itemName = this.newFolderText;
      this.tenantService
        .addTenantFolder(newFolder)
        .pipe(untilDestroyed(this))
        .subscribe((x) => {
          this.refreshData();
          this.newFolderText = '';
        });
    }
  }

  refreshData() {
    this.tenantService.getAllTenantsFolders().subscribe((x) => {
      this.folders = x;
    });
  }

  handleDeleteClick(folder: TenantFolderDto) {
    this.tenantService.deleteTenantFolder(folder.id!).subscribe(() => {
      this.refreshData();
    });
  }

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    table.filterGlobal(inputElement.value, 'contains');
  }
}
